module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.config && _vm.config.loading) ? _c('span', [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.config.loading.save),
      expression: "config.loading.save",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": "Processando..."
    }
  })]) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: _vm.id,
    attrs: {
      "label-position": "top",
      "label-width": "150px",
      "model": _vm.data
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.itens), function(item, i) {
    return (!_vm.config || !_vm.config.hidden || !_vm.config.hidden[item.field]) ? _c('div', {
      key: i,
      class: item.class,
      style: (item.style)
    }, [(item.type == 'group') ? _c('div', {
      staticClass: "col-12 item-group"
    }, [_c('i', {
      class: item.icon
    }), _vm._v("\n          " + _vm._s(item.label) + "\n        ")]) : (item.type != 'group') ? _c('el-form-item', {
      class: _vm.error && _vm.error[item.field] ? 'is-error' : '',
      attrs: {
        "label": item.label,
        "title": item.placeholder,
        "rules": _vm.handleRules(item.rules)
      }
    }, [(item.label) ? _c('span', {
      staticStyle: {
        "color": "#636363"
      },
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_c('span', [(_vm.config.label && _vm.config.label[item.field]) ? _c('label', [_vm._v(_vm._s(_vm.config.label[item.field]))]) : _c('label', [_vm._v(_vm._s(item.label))]), _vm._v(" "), (item.info && _vm.tooltipClick) ? _c('el-popover', {
      attrs: {
        "trigger": "click",
        "placement": "top",
        "width": "320",
        "title": item.label,
        "popper-class": "ed-form-info-popover-dark"
      }
    }, [_c('span', [_vm._v(_vm._s(item.info))]), _vm._v(" "), _c('a', {
      attrs: {
        "slot": "reference",
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
        }
      },
      slot: "reference"
    }, [_c('i', {
      staticClass: "fa fa-question-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : (item.info) ? _c('a', {
      attrs: {
        "href": "#",
        "title": item.info
      }
    }, [_c('i', {
      staticClass: "fa fa-question-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e(), _vm._v(" "), (item.title && item.title.model) ? _c('el-switch', {
      attrs: {
        "title": _vm.config.description ? _vm.config.description[item.title.model] : '',
        "active-value": 1,
        "inactive-value": 0,
        "active-text": _vm.config.title[item.title.model],
        "inactive-text": ""
      },
      model: {
        value: (_vm.data[item.title.model]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.title.model, $$v)
        },
        expression: "data[item.title.model]"
      }
    }) : _vm._e(), _vm._v(" "), (item.title && item.title.link && _vm.config.click[item.title.link]) ? _c('ed-button', {
      attrs: {
        "type": "text",
        "icon": item.title.icon,
        "value": _vm.config.title[item.title.link]
      },
      on: {
        "click": function($event) {
          _vm.config.click[item.title.link]()
        }
      }
    }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (item.type == 'text' || item.type == 'password' || item.type == 'textarea' || item.type == 'email' || item.type == 'number') ? _c('el-input', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: (item.mask ? _vm.mask[item.mask] : ''),
        expression: "item.mask ? mask[item.mask] : ''"
      }],
      class: {
        'input-uppercase': item.mask == 'cnpj' || item.mask == 'documento'
      },
      attrs: {
        "type": item.type,
        "rows": item.rows ? item.rows : 2,
        "maxlength": item.maxlength ? item.maxlength : 5000,
        "clearable": item.clearable ? true : false,
        "readonly": _vm.config.readonly && _vm.config.readonly[item.field] ? true : false,
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "prefix-icon": item.prefix ? item.prefix : '',
        "placeholder": item.placeholder,
        "show-word-limit": item.maxlength ? true : false,
        "autocomplete": "false"
      },
      on: {
        "input": function($event) {
          item.mask == 'cnpj' || item.mask == 'documento' ? _vm.data[item.field] = (_vm.data[item.field] || '').toUpperCase() : null
        }
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }) : (item.type == 'number') ? _c('el-input-number', {
      attrs: {
        "min": item.min ? item.min : 0,
        "max": item.max ? item.max : 99999999999,
        "clearable": item.clearable ? true : false,
        "readonly": _vm.config.readonly && _vm.config.readonly[item.field] ? true : false,
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "prefix-icon": item.prefix ? item.prefix : '',
        "placeholder": item.placeholder
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }) : (item.type == 'select-text' && _vm.config.list[item.select_field]) ? _c('el-input', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: (item.mask ? _vm.mask[item.mask] : ''),
        expression: "item.mask ? mask[item.mask] : ''"
      }],
      attrs: {
        "type": item.type,
        "rows": item.rows ? item.rows : 2,
        "maxlength": item.maxlength ? item.maxlength : 5000,
        "clearable": item.clearable ? true : false,
        "readonly": _vm.config.readonly && _vm.config.readonly[item.field] ? true : false,
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "prefix-icon": item.prefix ? item.prefix : '',
        "placeholder": item.placeholder,
        "show-word-limit": item.maxlength ? true : false,
        "autocomplete": "false"
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }, [_c('el-select', {
      staticStyle: {
        "width": "100px"
      },
      attrs: {
        "slot": "prepend",
        "placeholder": "---",
        "value-key": "id"
      },
      slot: "prepend",
      model: {
        value: (_vm.data[item.select_field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.select_field, $$v)
        },
        expression: "data[item.select_field]"
      }
    }, _vm._l((_vm.config.list[item.select_field]), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "data": item,
          "label": item.nome,
          "value": item.id
        }
      })
    }), 1)], 1) : (item.type == 'checkbox') ? _c('el-checkbox', {
      staticClass: "disable-checkbox-label",
      attrs: {
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "label": "1",
        "true-label": "1",
        "false-label": "0"
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }) : (item.type == 'color') ? _c('el-color-picker', {
      attrs: {
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "predefine": _vm.predefineColors,
        "color-format": "hex"
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }) : (item.type == 'boolean') ? _c('el-switch', {
      attrs: {
        "active-value": 1,
        "inactive-value": 0,
        "readonly": _vm.config.readonly && _vm.config.readonly[item.field] ? true : false,
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field])
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }) : (item.type == 'date') ? _c('el-date-picker', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: (_vm.mask.date),
        expression: "mask.date"
      }],
      attrs: {
        "type": "date",
        "placeholder": "dd/mm/aaaa",
        "value-format": "dd/MM/yyyy",
        "format": "dd/MM/yyyy",
        "picker-options": _vm.handleDateOptions(item),
        "clearable": item.clearable ? true : false,
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "readonly": _vm.config.readonly && _vm.config.readonly[item.field] ? true : false
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }) : (item.type == 'time') ? _c('el-time-select', {
      attrs: {
        "picker-options": _vm.handleTimeOptions(item),
        "clearable": item.clearable ? true : false,
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field])
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }) : (item.type == 'date-range') ? _c('el-date-picker', {
      attrs: {
        "type": "daterange",
        "placeholder": "dd/mm/aaaa",
        "value-format": "dd/MM/yyyy",
        "format": "dd/MM/yyyy",
        "clearable": item.clearable ? true : false,
        "start-placeholder": "Data Inicial",
        "end-placeholder": "Data Final",
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field])
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }) : (item.type == 'time-range') ? _c('el-time-picker', {
      attrs: {
        "is-range": "",
        "value-format": "HH:mm",
        "format": "HH:mm",
        "start-placeholder": "Início",
        "end-placeholder": "Fim"
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }) : (item.type == 'upload') ? _c('ed-upload', {
      attrs: {
        "input": item.field,
        "currentFile": _vm.data[item.field],
        "accept": item.accept ? item.accept : '',
        "multiple": item.multiple ? true : false,
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field])
      }
    }) : (item.type == 'cep') ? _c('el-input', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: (_vm.mask.cep),
        expression: "mask.cep"
      }],
      attrs: {
        "maxlength": item.maxlength ? item.maxlength : 10,
        "readonly": _vm.config.readonly && _vm.config.readonly[item.field] ? true : false,
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field])
      },
      on: {
        "blur": _vm.handleEndereco
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }) : (item.type == 'select-cnae') ? _c('el-select', {
      attrs: {
        "placeholder": "Selecione",
        "loading": _vm.loadingCnae,
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "filterable": "",
        "clearable": "",
        "remote": "",
        "remote-method": _vm.handleCnaeDebounce,
        "value-key": "cnae",
        "popper-append-to-body": true
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }, _vm._l((_vm.cnaes), function(cnae) {
      return _c('el-option', {
        key: cnae.id,
        attrs: {
          "label": cnae.cnae + ' | ' + cnae.nome,
          "value": cnae
        }
      })
    }), 1) : (item.type == 'select-uf') ? _c('el-select', {
      attrs: {
        "placeholder": "Selecione",
        "loading": _vm.loadingEstado,
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "filterable": "",
        "clearable": "",
        "popper-append-to-body": true
      },
      on: {
        "change": _vm.handleCidadeDebounce
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }, _vm._l((_vm.estados), function(estado) {
      return _c('el-option', {
        key: estado.uf,
        attrs: {
          "label": estado.estado.toUpperCase(),
          "value": item.value_uf ? estado.uf : estado.uf
        }
      })
    }), 1) : (item.type == 'select-cidade') ? _c('el-select', {
      attrs: {
        "placeholder": "Pesquisa...",
        "loading": _vm.loadingCidade,
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "filterable": "",
        "remote": "",
        "clearable": "",
        "remote-method": _vm.handleCidadeDebounce,
        "popper-append-to-body": true
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }, _vm._l((_vm.cidades), function(cidade) {
      return _c('el-option', {
        key: cidade.id_cidade,
        attrs: {
          "label": cidade.cidade.toUpperCase(),
          "value": cidade.id_cidade
        }
      })
    }), 1) : (item.type == 'editor') ? _c('ed-editor', {
      attrs: {
        "conteudo": _vm.data[item.field],
        "model": item.field
      }
    }) : (item.type == 'select-tipo') ? _c('ed-select-tipo', {
      attrs: {
        "items": _vm.tipos[item.tipo],
        "clearable": item.clearable ? true : false,
        "multiple": item.multiple ? true : false,
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "placeholder": item.placeholder ? item.placeholder : 'Selecione',
        "valor-field": item.valor
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }) : (item.type == 'select-tipo-radio') ? _c('el-radio-group', {
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }, _vm._l((_vm.tipos[item.tipo]), function(tipo) {
      return _c('el-radio', {
        key: tipo.id,
        staticStyle: {
          "padding": "5px"
        },
        attrs: {
          "label": item.valor ? _vm.toString(tipo[item.valor]) : parseInt(tipo.id),
          "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field] ? true : false)
        }
      }, [_vm._v("\n              " + _vm._s(tipo.descricao) + "\n            ")])
    }), 1) : (item.type == 'select-tipo-checkbox') ? _c('div', _vm._l((_vm.tipos[item.tipo]), function(tipo) {
      return _c('el-checkbox', {
        key: tipo.id,
        staticStyle: {
          "padding": "5px",
          "width": "100% !important"
        },
        attrs: {
          "label": item.valor ? tipo[item.valor] : tipo.id,
          "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field] ? true : false)
        },
        model: {
          value: (_vm.data[item.field]),
          callback: function($$v) {
            _vm.$set(_vm.data, item.field, $$v)
          },
          expression: "data[item.field]"
        }
      }, [_vm._v("\n              " + _vm._s(tipo.descricao) + "\n            ")])
    }), 1) : (item.type == 'select-custom' && _vm.config.click && _vm.config.click[item.field] && _vm.config.list && _vm.config.list[item.field]) ? _c('el-select', {
      attrs: {
        "clearable": item.clearable ? true : false,
        "loading": _vm.config.loading[item.field],
        "placeholder": item.placeholder ? item.placeholder : 'Pesquisar...',
        "filterable": "",
        "disabled": _vm.config.disabled && _vm.config.disabled[item.field] ? true : false,
        "multiple": item.multiple ? true : false,
        "collapse-tags": "",
        "remote": "",
        "remote-method": item.disable_remote ? null : _vm.config.click[item.field],
        "value-key": "id",
        "popper-append-to-body": true
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }, _vm._l((_vm.config.list[item.field]), function(val, j) {
      return _c('el-option', {
        key: j,
        attrs: {
          "label": _vm.handleLabelSelect(item, val),
          "value": _vm.handleValueSelect(item, val),
          "title": _vm.handleTitleSelect(item, val)
        }
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.handleLabelSelectHtml(item, val))
        }
      })])
    }), 1) : (item.type == 'select-ghe' && _vm.config.click && _vm.config.click[item.field] && _vm.config.list && _vm.config.list[item.field]) ? _c('el-select', {
      attrs: {
        "clearable": item.clearable ? true : false,
        "loading": _vm.config.loading[item.field],
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "placeholder": "Selecione",
        "filterable": "",
        "popper-append-to-body": true
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }, _vm._l((_vm.config.list[item.field]), function(revisao) {
      return _c('el-option-group', {
        key: revisao.id,
        attrs: {
          "label": (revisao.parent ? revisao.parent.rev + ' (' + revisao.parent.descricao.toUpperCase() + ' em ' + _vm.toDate(revisao.parent.data_hora, true) + ') / ' : '') + revisao.rev + ' (' + revisao.descricao.toUpperCase() + ' em ' + _vm.toDate(revisao.data_hora, true) + ')'
        }
      }, _vm._l((revisao.options), function(ghe) {
        return _c('el-option', {
          key: revisao.id + ghe.id,
          attrs: {
            "label": ghe.id == '0' ? ghe.descricao : ghe.ghe + ' (' + ghe.descricao + ')',
            "value": ghe.id,
            "disabled": ghe.id == '0' || revisao.disabled || (revisao.parent && revisao.parent.disabled) || (_vm.config.disabled && _vm.config.disabled[item.field]) ? true : false,
            "title": revisao.disabled || (revisao.parent && revisao.parent.disabled) ? 'O PCMSO desde GHE está vencido. Entre em contato conosco para melhores esclarecimentos.' : ''
          }
        })
      }), 1)
    }), 1) : (item.type == 'select-revisao' && _vm.config.click && _vm.config.click[item.field] && _vm.config.list && _vm.config.list[item.field]) ? _c('el-select', {
      attrs: {
        "clearable": item.clearable ? true : false,
        "loading": _vm.config.loading[item.field],
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "placeholder": "Selecione",
        "filterable": "",
        "popper-append-to-body": true
      },
      on: {
        "change": function($event) {
          _vm.config.change[item.field](_vm.data[item.field])
        }
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }, _vm._l((_vm.config.list[item.field]), function(revisao, j) {
      return _c('el-option-group', {
        key: j,
        attrs: {
          "label": revisao.label,
          "value-key": "id"
        }
      }, _vm._l((revisao.options), function(val, k) {
        return _c('el-option', {
          key: k,
          attrs: {
            "label": _vm.handleLabelSelect(item, val),
            "value": _vm.handleValueSelect(item, val),
            "title": _vm.handleTitleSelect(item, val)
          }
        }, [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.handleLabelSelectHtml(item, val))
          }
        })])
      }), 1)
    }), 1) : (item.type == 'limite-credito') ? _c('div', [_c('el-radio', {
      attrs: {
        "label": 1
      },
      model: {
        value: (_vm.data.ilimitada),
        callback: function($$v) {
          _vm.$set(_vm.data, "ilimitada", $$v)
        },
        expression: "data.ilimitada"
      }
    }, [_vm._v("Ilimitada")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": 0
      },
      model: {
        value: (_vm.data.ilimitada),
        callback: function($$v) {
          _vm.$set(_vm.data, "ilimitada", $$v)
        },
        expression: "data.ilimitada"
      }
    }, [_vm._v("\n              Com limite de\n              "), _c('input', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: ('money'),
        expression: "'money'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.data.limite),
        expression: "data.limite"
      }],
      staticClass: "el-input__inner",
      style: ('width:200px !important;' + (_vm.data.ilimitada == 1 ? 'background:#ececec' : '')),
      attrs: {
        "placeholder": "Informe o valor",
        "prefix-icon": "fa fa-usd",
        "disabled": _vm.data.ilimitada == 1
      },
      domProps: {
        "value": (_vm.data.limite)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.data, "limite", $event.target.value)
        }
      }
    })])], 1) : _vm._e(), _vm._v(" "), (_vm.error && _vm.error[item.field]) ? _c('div', {
      staticClass: "mt-1",
      staticStyle: {
        "color": "#e66666",
        "font-size": "9pt"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.error[item.field][0]) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.config.obs && _vm.config.obs[item.field]) ? _c('div', {
      staticStyle: {
        "font-size": "9pt"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.config.obs[item.field])
      }
    }) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_vm._t("form-itens")], 2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_vm._t("form-footer")], 2), _vm._v(" "), (_vm.config && _vm.config.click && _vm.config.click.save) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('ed-button', {
    attrs: {
      "loading": _vm.config.loading.save,
      "icon": "fa fa-save",
      "type": "success",
      "value": " Salvar"
    },
    on: {
      "click": _vm.handlerSave
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.data.usuario && _vm.data.updated_at) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-1"
  }, [_c('ed-alert', {
    attrs: {
      "type": "success"
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('b', [_vm._v("Última Atualização:")]), _vm._v(" " + _vm._s(_vm.data.usuario.usuario) + " em " + _vm._s(_vm.toDate(_vm.data.updated_at)))])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2"
  }, [_c('ed-error', {
    attrs: {
      "title": "Atenção",
      "type": "error",
      "response": _vm.response
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center"
  }, [_vm._t("form-end")], 2)], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a7435d38"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/common/form.vue
// module id = 1563
// module chunks = 45